import EditPanel from '../components/ResultPage/EditPanel';
import ResponseHeader from '../components/ResultPage/ResponseHeader';
import ResponseSection from '../components/ResultPage/ResponseSection';
import { useFormOptions } from '../hooks/useFormOptions';

export default function SocialMediaResponsePage() {
  const { data, isLoading, isSuccess } = useFormOptions();

  return (
    <main className="flex h-full gap-3">
      <div className="flex text-text-primary flex-col flex-1 rounded-md bg-background">
        <ResponseHeader />
        <ResponseSection />
      </div>

      {/* EditPanel - Only visible on desktop */}
      {!isLoading && isSuccess && (
        <div className="hidden lg:block">
          <EditPanel formOptions={data} />
        </div>
      )}
    </main>
  );
}
